'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const MAXIMUM_BACKGROUND_MS = 1000 * 60 * 60;
class StalePageRefresher {
    monitor() {
        document.addEventListener('visibilitychange', this.handleVisibilityChange, false);
    }
    pause() {
        document.removeEventListener('visibilitychange', this.handleVisibilityChange, false);
    }
    handleVisibilityChange() {
        if (document.hidden) {
            this.hiddenAt = new Date();
        }
        else if (this.hiddenAt) {
            const msInBackground = new Date().getTime() - this.hiddenAt.getTime();
            if (msInBackground > MAXIMUM_BACKGROUND_MS) {
                window.location.reload();
            }
        }
    }
}
var index = new StalePageRefresher();

exports.default = index;
//# sourceMappingURL=index.js.map
